import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const CTASection = () => {
  const { isDark } = useTheme();

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className={`py-16 sm:py-24 lg:py-32 ${isDark ? 'bg-[#111916]' : 'bg-white'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className={`relative rounded-2xl sm:rounded-3xl p-8 sm:p-12 md:p-16 lg:p-20 overflow-hidden ${
          isDark 
            ? 'bg-gradient-to-br from-[#1A2420] to-[#0A0F0D] border border-green-900/30' 
            : 'bg-gradient-to-br from-green-50 to-white border border-green-100'
        }`}>
          {/* Background decoration */}
          <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-green-500/5 to-transparent" />
          <div className="absolute bottom-0 left-0 w-1/3 h-1/2 bg-gradient-to-t from-amber-500/5 to-transparent" />
          
          <div className="relative z-10 text-center max-w-3xl mx-auto">
            <h2 className="font-display font-bold leading-tight mb-4 sm:mb-6" style={{ fontSize: 'clamp(1.5rem, 4vw, 2.75rem)' }}>
              <span className={isDark ? 'text-white' : 'text-gray-900'}>Ready to </span>
              <span className="gradient-text">Transform Your Business?</span>
            </h2>
            <p className={`text-sm sm:text-base lg:text-lg mb-8 sm:mb-10 ${
              isDark ? 'text-gray-400' : 'text-gray-600'
            }`}>
              Let's discuss how our renewable energy, agro-culture, and engineering solutions 
              can help you achieve sustainable growth and improved productivity.
            </p>
            <button
              onClick={scrollToContact}
              className="group inline-flex items-center gap-2 sm:gap-3 bg-gradient-to-r from-[#006633] to-[#00873D] text-white font-semibold text-sm sm:text-base px-6 sm:px-10 py-4 sm:py-5 rounded-full hover:shadow-xl hover:shadow-green-500/25 hover:scale-[1.02] active:scale-[0.98] transition-all duration-300"
            >
              Start a Conversation
              <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
